import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
  ViewContainerRef,
} from "@angular/core";
import { TabsetComponent, TabDirective } from "ngx-bootstrap/tabs";
import {
  LOGIN_TYPES,
  PaymentProviderIDs,
  TabNames,
  c1,
  c16,
} from "src/app/core/services/constants";
import { ImgUploadService, UploadQueueItem } from "src/app/core/services/img-upload.service";
import { IndexDBService } from "src/app/core/services/indexDB.service";
import { Tab } from "src/app/core/services/interface";
import { MiddlwareService } from "src/app/core/services/middleware.service";
import { MessageAIModule, StartAIBuilder } from "src/app/core/services/outbound";
import { WebsocketService } from "src/app/core/services/websocket.service";
import { BuilderService } from "src/app/sharedservices/builder.service";

@Component({
  selector: "app-offcanvas-ai-settings",
  templateUrl: "./offcanvas-ai-settings.component.html",
  styleUrls: ["./offcanvas-ai-settings.component.scss"],
})
export class OffcanvasAiSettingsComponent implements OnInit, OnDestroy {
  @ViewChild('scrollContainer') scrollContainer!: ElementRef;
  @ViewChild('messagesContainer') private messagesContainer!: ElementRef<HTMLDivElement>;
  @Input() itemName;
  @Input() input;
  module = "bot";
  moduleId = "123456789";
  @Input() moduleObject = {bot:{}, token:"", privileges: []};
  @Input() component_ref = this.mdw.makeRef(16);
  @Output() outputNotifier = new EventEmitter<any>(null);
  @Output() closeNotifier = new EventEmitter<any>(null);

  offcanvas_data: any = [];
  offCanvasSubscription: any;

  updatedBuilderComponentSubscription: any;
  messageAIModuleSubscription: any;
  getAIModuleHistorySubscription: any;
  verifySubscription: any;
  // default values
  colors;
  bg_color;
  text_color;
  burger_icon_color;
  app_name_color;
  other_text_color;
  channel_name: string;
  off_canvas_key = "gen";

  page_id: string;
  title: string;
  hideoffcanvas: boolean;
  current_tab: string;
  active_tabset_index: number = 0;
  tab: Tab;
  updateBuilderComponentSubscription: any;
  data: any;
  login_types = LOGIN_TYPES;
  paymentProviderIDs = PaymentProviderIDs;

  menu_id: any;
  minimized: boolean = false;
  messages: any = [
    // {
    //   role: "assistant",
    //   content: "Hi,<br> Let’s get started with your app setup.<br>**First, tell me what your app is all about.**"
    // },
    // {
    //   role: "user",
    //   content: "Whatsapp"
    // }
  ]
  loadingMessage = false;
  thinkingMessage = false;
  doneMessage = false;
  errorMessage = false;
  web: string;

  mode = "light";
  generating = false;
  theme = "frozen";
  placement = "frozen";
  signup = "frozen";
  onboarding = "frozen";
  custom = "frozen";
  uploading = "frozen";
  final = "frozen";
  completed_images;
  total_images;
  disableInput = false;
  state = 1000;
  remind = false;
  remindCounter = 0;
  showTopbar = false;

  inputText = '';

  messageQueue: any = [];
  isProcessingQueue = false;

  displayedMessage = "";
  messageIndex: number = 0;
  typingSpeed: number = 1; // Adjust speed as needed
  typingSessionId = 0;
  status;

  app_info: any;
  app_icon: any;
  logoColor: any;
  updatedVersion: boolean;
  isAndroid: boolean;
  originalColors: any = {};

  queue$ = this.imgUpload.queue$;

  constructor(
    private ws: WebsocketService,
    private mdw: MiddlwareService,
    public indexDBService: IndexDBService,
    private ref: ChangeDetectorRef,
    private builderService: BuilderService,
    private cdr: ChangeDetectorRef,
    private imgUpload: ImgUploadService
  ) {}

  ngOnInit() {
    this.offCanvasSubscription = this.mdw.offCanvasContainer$.subscribe(
      (data) => {
        this.data = data;
        this.OffCanvasData(data);
      }
    );

    this.updateBuilderComponentSubscription =
      this.mdw.updateBuilderComponentContainer$.subscribe((data) => {
        if (data && data.offcanvasRefersh && data.tab) {
          // offcanvasRefresh prevents flickering and prevent the component (offcanvas) to update itself and then components flikers.
          // only update from outside component can send updated data to the offcanvas.
          this.OffCanvasData(this.data);
        }
      });

    this.messageAIModuleSubscription = this.ws.messageAIModuleContainer$.subscribe((messageData) => {
      if(messageData){
        this.messageQueue.push(messageData);
        this.processMessageQueue();
        this.cdr.detectChanges();
      }
    });

    this.getAIModuleHistorySubscription = this.ws.getAIModuleHistoryContainer$.subscribe((moduleHistory) => {
      if(moduleHistory){
        console.log("moduleHistory", moduleHistory)

        if(moduleHistory.history){
          moduleHistory.history.forEach((chat, index) => {
            if(chat.role == 'assistant'){
              let json_response = JSON.parse(chat?.content);
              if(json_response.content != null){
                chat.content = json_response.content.replace(/\\n/g, '\n').replace(/\n/g, '\n\n')
              }else{
                chat.content = "";
                // moduleHistory.history.splice(index, 1);
              }
            }
            if(chat.role == 'user'){
              chat.content = chat.content[0].text.replace(/\\n/g, '\n').replace(/\n/g, '<br>');
            }
          });
          this.messages = moduleHistory.history;
          if(this.messages.length > 0 && !this.doneMessage){
            let lastMessage = this.messages[this.messages.length - 1];
            if (lastMessage.role === 'assistant') {
              this.displayedMessage = '';
              this.messageIndex = 0;
              this.startTypingNewMessage(lastMessage.content);
            }
          }
        console.log(this.messages);
        this.loadingMessage = false;
        this.disableInput = false;
        }
        if(moduleHistory.state){

          this.state = moduleHistory.state;
        console.log("state1", this.state)

        }
      }
    });

    this.verifySubscription = this.ws.verifyContainer$.subscribe((verifyData) => {
      if (verifyData) {

        console.log("The input", this.input);
        console.log("module: ", this.module, "moduleId:", this.moduleId, this.moduleObject, "Status:" ,"init", "ref:", this.component_ref);

        // this.ws.processMethod(new StartAIBuilder(this.module, this.moduleId, "init", this.component_ref, this.moduleObject));

        this.loadingMessage = true;
        this.disableInput = true;
        this.updatedBuilderComponentSubscription = this.mdw.updateBuilderComponentContainer$.subscribe(async (data) => {
          if (data) {
            this.colorInitialize();
            // this.app_info = this.config.appConfig.app.system.app_info;;
            if (this.app_info && this.app_info.image) {
              this.app_icon = this.app_info.image;
            }
            if (
              this.app_info &&
              this.app_info.color_logo &&
              this.app_info.color_logo.bg
            ) {
              this.logoColor = this.app_info.color_logo_bg.bg;
            }
            this.updatedVersion = localStorage.getItem("version") == "1"? true: false;
          }
        });
      }
    });
  }

  OffCanvasData(data) {
    if (data) {
      if (data.off_canvas_key === "ai") {
        this.page_id = data.page.id;
        this.current_tab = data.tab;
        this.title = data.page.title;
        this.hideoffcanvas = true;
        switch (data.page.id) {
          case "nav_tab":
            this.tab = data.tab; // to fire after changes
            this.active_tabset_index =
              localStorage.getItem("mode")[0] == c1.ANDROID ? 0 : 1; // to select initial opening setting tab.

            this.offcanvas_data = [
              {
                tab: "ANDROID",
                id: c1.ANDROID,
                icon: "fab fa-android",
                active: this.activeTabSetting(data.page.id, 0),

                data: [
                  {
                    cat: "Basic",
                    show: false,
                    list: [
                      { anavtab: true },
                      { anavtabstyle: true },
                      { atabswiping: true },
                      { anavcolor: false },
                      { enableAppbar: true }
                    ],
                  },
                ],
              },
              {
                tab: "iOS",
                id: c1.IOS,
                icon: "fab fa-apple",
                active: this.activeTabSetting(data.page.id, 1),
                data: [
                  {
                    cat: "Basic",
                    show: false,
                    list: [
                      { inavinfo: true },
                      { inavtabstyle: true },
                      { inavcolor: false },
                    ],
                  },
                ],
              },
            ];
            break;
          case "nav_side":
            this.tab = data.tab; // to fire after changes
            this.active_tabset_index =
              localStorage.getItem("mode")[0] == c1.ANDROID ? 0 : 1; // to select initial opening setting tab.

            this.offcanvas_data = [
              {
                tab: "ANDROID",
                id: c1.ANDROID,
                icon: "fab fa-android",
                active: this.activeTabSetting(data.page.id, 0),

                data: [
                  {
                    cat: "Basic",
                    show: false,
                    list: [
                      { asidetoggle: true },
                      { asidecolor: false },
                      { sideUser: true },
                    ],
                  },
                ],
              },
              {
                tab: "iOS",
                id: c1.IOS,
                icon: "fab fa-apple",
                active: this.activeTabSetting(data.page.id, 1),
                data: [
                  {
                    cat: "Basic",
                    show: false,
                    list: [
                      { isidetoggle: true },
                      { iside: true },
                      { isideinfo: true },
                      { sideUser: true },
                    ],
                  },
                ],
              },
            ];
            break;
          // case "nav_side":
          //     this.tab = data.tab; // to fire after changes
          //     this.active_tabset_index =
          //       localStorage.getItem("mode")[0] == c1.ANDROID ? 0 : 1; // to select initial opening setting tab.

          //     this.offcanvas_data = [
          //       {
          //         tab: "ANDROID",
          //         id: c1.ANDROID,
          //         icon: "fab fa-android",
          //         active: this.activeTabSetting(data.page.id, 0),
          //         data: [
          //           {
          //             cat: "Basic",
          //             show: false,
          //             list: [{ asidetoggle: true }, { asidecolor: true }],
          //           },
          //         ],
          //       },
          //       {
          //         tab: "iOS",
          //         id: c1.IOS,
          //         icon: "fab fa-apple",
          //         active: this.activeTabSetting(data.page.id, 1),
          //         data: [
          //           {
          //             cat: "Basic",
          //             show: false,
          //             list: [
          //               { isidetoggle: true },
          //               { iside: true },
          //               { isideinfo: true },
          //             ],
          //           },
          //         ],
          //       },
          //     ];

          //     break;
          case this.login_types.EMAIL:
            this.tab = data.tab; // to fire after changes
            this.active_tabset_index =
              localStorage.getItem("mode")[0] == c1.ANDROID ? 0 : 1; // to select initial opening setting tab.

            this.offcanvas_data = [
              {
                tab: "ANDROID",
                id: c1.ANDROID,
                icon: "fab fa-android",
                active: this.activeTabSetting(data.page.id, 0),
                data: [
                  {
                    cat: "Basic",
                    show: false,
                    list: [
                      { buttonapploginmessagehtml: true },
                      { buttonsmtpserver: true },
                      { buttonAllowUsertoChangeEmail: true },
                      { buttonAppLoginverificationaccount: true },
                    ],
                  },
                ],
              },
            ];
            break;
          case this.login_types.MSISDN:
            this.tab = data.tab; // to fire after changes
            this.active_tabset_index =
              localStorage.getItem("mode")[0] == c1.ANDROID ? 0 : 1; // to select initial opening setting tab.

            this.offcanvas_data = [
              {
                tab: "ANDROID",
                id: c1.ANDROID,
                icon: "fab fa-android",
                active: this.activeTabSetting(data.page.id, 0),
                data: [
                  {
                    cat: "Basic",
                    show: false,
                    list: [
                      { buttonapploginmessagehtml: true },
                      { buttonAppLoginVendorsMobile: true },
                      { buttonAppLoginverificationaccount: true },
                    ],
                  },
                ],
              },
            ];
            break;
          case this.login_types.NO_LOGIN:
            this.hideoffcanvas = false;
            this.offcanvas_data = [];
            break;
          case this.paymentProviderIDs.STRIPE:
            this.tab = data.tab; // to fire after changes
            this.active_tabset_index =
              localStorage.getItem("mode")[0] == c1.ANDROID ? 0 : 1; // to select initial opening setting tab.

            this.offcanvas_data = [
              {
                tab: "ANDROID",
                id: c1.ANDROID,
                icon: "fab fa-android",
                active: this.activeTabSetting(data.page.id, 0),
                data: [
                  {
                    cat: "Basic",
                    show: false,
                    list: [{ buttonAppPaymentStripe: true }],
                  },
                ],
              },
            ];
            break;
          case this.paymentProviderIDs.GOOGLEPAY:
            this.tab = data.tab; // to fire after changes
            this.active_tabset_index =
              localStorage.getItem("mode")[0] == c1.ANDROID ? 0 : 1; // to select initial opening setting tab.

            this.offcanvas_data = [
              {
                tab: "ANDROID",
                id: c1.ANDROID,
                icon: "fab fa-android",
                active: this.activeTabSetting(data.page.id, 0),
                data: [
                  {
                    cat: "Basic",
                    show: false,
                    list: [{ buttonAppPaymentGooglepay: true, gateway: data.page.gateway }],
                  },
                ],
              },
            ];
            break;
          case this.paymentProviderIDs.APPLEPAY:
            this.tab = data.tab; // to fire after changes
            this.active_tabset_index =
              localStorage.getItem("mode")[0] == c1.ANDROID ? 0 : 1; // to select initial opening setting tab.

            this.offcanvas_data = [
              {
                tab: "ANDROID",
                id: c1.ANDROID,
                icon: "fab fa-android",
                active: this.activeTabSetting(data.page.id, 0),
                data: [
                  {
                    cat: "Basic",
                    show: false,
                    list: [{ buttonAppPaymentApplepay: true, gateway: data.page.gateway }],
                  },
                ],
              },
            ];
            break;
          case this.paymentProviderIDs.PAYPAL:
            this.tab = data.tab; // to fire after changes
            this.active_tabset_index =
              localStorage.getItem("mode")[0] == c1.ANDROID ? 0 : 1; // to select initial opening setting tab.

            this.offcanvas_data = [
              {
                tab: "ANDROID",
                id: c1.ANDROID,
                icon: "fab fa-android",
                active: this.activeTabSetting(data.page.id, 0),
                data: [
                  {
                    cat: "Basic",
                    show: false,
                    list: [{ buttonAppPaymentPaypal: true }],
                  },
                ],
              },
            ];
            break;
          case this.paymentProviderIDs.INAPPGOOGLE:
            this.tab = data.tab; // to fire after changes
            this.active_tabset_index =
              localStorage.getItem("mode")[0] == c1.ANDROID ? 0 : 1; // to select initial opening setting tab.

            this.offcanvas_data = [
              {
                tab: "ANDROID",
                id: c1.ANDROID,
                icon: "fab fa-android",
                active: this.activeTabSetting(data.page.id, 0),
                data: [
                  {
                    cat: "Basic",
                    show: false,
                    list: [{ buttonAppPaymentInappPurchases: true }],
                  },
                ],
              },
              {
                tab: "iOS",
                id: c1.IOS,
                icon: "fab fa-apple",
                active: this.activeTabSetting(data.page.id, 1),
                data: [
                  {
                    cat: "Basic",
                    show: false,
                    list: [],
                  },
                ],
              },
            ];
            break;
          case this.paymentProviderIDs.GOOGLEPROVIDER:
            this.tab = data.tab; // to fire after changes
            this.active_tabset_index =
              localStorage.getItem("mode")[0] == c1.ANDROID ? 0 : 1; // to select initial opening setting tab.

            this.offcanvas_data = [
              {
                tab: "ANDROID",
                id: c1.ANDROID,
                icon: "fab fa-android",
                active: this.activeTabSetting(data.page.id, 0),
                data: [
                  {
                    cat: "Basic",
                    show: false,
                    list: [{ buttonAppPaymentGoogleAdsAndroid: true }],
                  },
                ],
              },
              {
                tab: "iOS",
                id: c1.IOS,
                icon: "fab fa-apple",
                active: this.activeTabSetting(data.page.id, 1),
                data: [
                  {
                    cat: "Basic",
                    show: false,
                    list: [{ buttonAppPaymentGoogleAdsIOS: true }],
                  },
                ],
              },
            ];
            break;
          case "menu":
            this.tab = data.tab; // to fire after changes
            this.menu_id = data.menu_id;
            this.active_tabset_index =
              localStorage.getItem("mode")[0] == c1.ANDROID ? 0 : 1; // to select initial opening setting tab.
            this.offcanvas_data = [
              {
                tab: "ANDROID",
                id: c1.ANDROID,
                icon: "fab fa-android",
                active: this.activeTabSetting(data.page.id, 0),
                data: [
                  {
                    cat: "Basic",
                    show: false,
                    list: [
                      {
                        menuBgImage: true,
                        config: {
                          id: "button_color_icon",
                          name: "Option",
                          image: true,
                          imageType: "image/jpeg,image/pjpeg,image/png",
                          aspectRatio: "0.5x1",
                          resizeToWidth: 560,
                          resizeToHeight: 1200,
                          cropperView: true,
                          keyword: "menu",
                          title: "Menu Background Image",
                          removeButton: true,
                          isDark: true,
                        },
                      },
                      {
                        menuBgColor: true,
                        config: {
                          id: "menu_bg_color",
                          init_start: 'primaryContainer',
                          init_end: 'primary',
                          init_start_ios: 'primaryContainer',
                          init_end_ios: 'primary',
                        },
                      },
                    ],
                  },
                ],
              },
            ];
            break;
          default:
            {
              this.hideoffcanvas = true;
            }
            break;
        }
        if (this.hideoffcanvas && data.show) {
          this.showOffcanvas();
          this.hideoffcanvas = false;
        } else {
          this.hideOffcanvas();
        }
        this.off_canvas_key = data.off_canvas_key;
      } else {
        this.hideOffcanvas();
      }
    }
  }
  // another way to set the active tab. without markign the html with [active] tag
  // https://stackblitz.com/edit/ngx-bootstrap-tabs-manual?file=app%2Fapp.component.ts
  // goto(id){
  //   this.tabset.tabs[id].active = true;
  // }

  activeTabSetting(pageId, tabIndex) {
    if (pageId === this.page_id) {
      if (tabIndex === this.active_tabset_index) {
        return true;
      } else return false;
    } else return false;
  }

  tabSetChange(event) {
    // only active to trigger on certian page components
    switch (this.page_id) {
      case "nav_tab":
      case "nav_side":
        this.setMobileThemeC1(event);

        break;
    }
  }

  setMobileThemeC1(event) {
    let modes: any;
    if (event.id !== localStorage.getItem("mode")[0]) {
      // only if there is a change we will broadcast. This will prevent looping between the two components which are switching views
      // they are doing ping pong as the changes detected using TabSelect()

      if (event.id == c1.IOS) {
        modes = [{ id: c1.ID, value: c1.IOS }];
      } else {
        modes = [{ id: c1.ID, value: c1.ANDROID }];
      }
      this.mdw.changeMobileTheme(modes);
      let data = { ...{ tab: this.tab } };

      this.mdw._updateBuilderComponentContainer.next(data);
    }
  }

  colorInitialize(){
    try {
      const appHome = this.indexDBService.getItem("app", 'home');
      appHome.onsuccess = async (event) => {
        if (appHome.result) {
          this.originalColors['color_schema'] = appHome.result.app.tabs.color_schema;
          this.originalColors['color_schema_ios'] = appHome.result.app.tabs.color_schema_ios;
          this.originalColors['light'] = localStorage.getItem("mode")[15] == c16.LIGHT? true:false
          this.isAndroid = localStorage.getItem("mode")[0] == c1.ANDROID? true: false;
        }
      }
    } catch (error) {
    }
  }

  getLogoBackground(){
    if(this.originalColors.color_schema){
      return this.isAndroid ? this.originalColors.color_schema.schemes.light.icLauncherBackground : '#ffffff';
    } else {
      return '#ffffff';
    }
  }

  hideOffcanvas() {
    document
      .querySelector("#offcanvasScrollingAIConf")
      .classList.remove("show");
  }

  showOffcanvas() {
    document.querySelector("#offcanvasScrollingAIConf").classList.add("show");
  }

  adjustHeight(event: Event): void {
    const textarea = event.target as HTMLTextAreaElement;
    textarea.style.height = 'auto';
    textarea.style.height = `${textarea.scrollHeight}px`;
  }

  submitAnswer() {
    let imageUrls = this.imgUpload.getUploadedUrls();
    if (this.inputText.trim() && !(this.loadingMessage || this.doneMessage)) {
      this.messages.push({content: this.inputText, role: "user"})
      this.ws.processMethod(new MessageAIModule(this.inputText, this.state, this.module, this.moduleId, this.component_ref, this.remind, false, imageUrls));
      this.disableInput = true;
      this.loadingMessage = true;
      this.thinkingMessage = true;
      setTimeout(() => this.scrollToBottom(), 0);
      setTimeout(() => {
        this.inputText = '';
        document.getElementById("inputArea").style.height = "";
        const container = this.scrollContainer?.nativeElement;
        if(container){
          container.scrollTop = container.scrollHeight;
        }
      });
    }

    this.inputText = '';
    this.imgUpload.clearDone();
  }

  help(){
    this.disableInput = true;
    this.messages.push({content: "Can you give me some suggestions for how to answer?", role: "user"})
    this.ws.processMethod(new MessageAIModule("Can you give me some suggestions for how to answer?", this.state, this.module, this.moduleId, this.component_ref, this.remind));
    this.inputText = '';
    this.loadingMessage = true;
    this.thinkingMessage = true;
    setTimeout(() => this.scrollToBottom(), 0);
    setTimeout(() => {
      const container = this.scrollContainer.nativeElement;
      container.scrollTop = container.scrollHeight;
    });
  }

  accept(){
    this.disableInput = true;
    this.messages.push({content: "👍", role: "user"})
    this.ws.processMethod(new MessageAIModule("👍", this.state, this.module, this.moduleId, this.component_ref, this.remind));
    this.inputText = '';
    this.loadingMessage = true;
    this.thinkingMessage = true;
    setTimeout(() => this.scrollToBottom(), 0);
    setTimeout(() => {
      const container = this.scrollContainer.nativeElement;
      container.scrollTop = container.scrollHeight;
    });
  }

  decline(){
    this.disableInput = true;
    this.messages.push({content: "👎", role: "user"})
    this.ws.processMethod(new MessageAIModule("👎", this.state, this.module, this.moduleId, this.component_ref, this.remind));
    this.inputText = '';
    this.loadingMessage = true;
    this.thinkingMessage = true;
    setTimeout(() => this.scrollToBottom(), 0);
    setTimeout(() => {
      const container = this.scrollContainer.nativeElement;
      container.scrollTop = container.scrollHeight;
    });
  }

  scrollToBottom() {
    if (this.messagesContainer) {
      this.messagesContainer.nativeElement.scrollTop = this.messagesContainer.nativeElement.scrollHeight;
    }
  }

  async processMessageQueue(){
    console.log(this.isProcessingQueue, this.messageQueue.length);
    if (this.isProcessingQueue || this.messageQueue.length === 0) return;

    this.isProcessingQueue = true;
    const data = this.messageQueue.shift();



    this.web = data.web;
    this.module = data.module;
    this.state = data.state;
    this.moduleId = data.module_id;
    this.status = data.status;

    console.log("this.web ", this.web)
    console.log("this.module ", this.module)
    console.log("messageData", data)

    let mode = data.mode;

    let outputs = data.output;
    let key = data.key;
    if(this.state == data.state || this.web == "generate"){
      this.loadingMessage = false;
      this.disableInput = false;
    }

    if(this.state == data.state){
      this.remindCounter++;
    } else {
      this.thinkingMessage = false;
      this.remindCounter = 0;
      this.remind = false;
    }


    if(this.remindCounter > 5){
      this.remind = true;
    }

  //  if(this.state > 2000 || this.web == "generate"){
  //     this.isSidebarOpen = true;
  //   }

    // let content;
    // try {
    //   content = JSON.parse(data?.response?.content);
    // } catch (e) {
    //   console.error("Failed to parse AI response", e);
    //   this.isProcessingQueue = false;
    //   return this.processMessageQueue(); // move to next
    // }

    let message = data?.response?.content;
    let found = false;
    if(outputs != null){
      outputs.forEach(output => {
        if(output != null && data?.response?.json_config != null && data?.response?.json_config[output] != null){
          let value = data?.response?.json_config[output];
        }
      });
    }

    found = false;
    console.log("key", key);
    console.log("data?.response?.json_config", data?.response?.json_config);

    if(key != null){
      if(data?.response?.json_config != null && data?.response?.json_config[key] != null){
        found = true;
        console.log("++++++found++++++++++")
      }
    }
    if(found){
      this.loadingMessage = false;
      this.disableInput = true;
    }

      if(mode == "interactive" && message != null){
        this.messages.push({content: message?.replace(/\\n/g, '\n').replace(/\n/g, '\n\n'), role: "assistant"});
        this.displayedMessage = ''; // Clear previous message display
        this.messageIndex = 0;
        this.startTypingNewMessage(message);
      }

    if(this.web == "generate"){
            this.doneMessage = true;
        }

    setTimeout(() => {
      const inputArea = document.getElementById('inputArea');
      if (inputArea) {
        inputArea.focus();
      }
    }, 100);

    setTimeout(() => this.scrollToBottom(), 0);
    setTimeout(() => {
      if(this.scrollContainer?.nativeElement){
        const container = this.scrollContainer.nativeElement;
        container.scrollTop = container.scrollHeight;
      }
      // if (this.sidebarRef?.nativeElement) {
      //   const el = this.sidebarRef.nativeElement;
      //   el.scrollTo({ top: el.scrollHeight, behavior: 'smooth' });
      // }
    });
    this.isProcessingQueue = false;
    this.processMessageQueue();
  }

  async handleMessageAnimation(message){
    this.messages.push({
      content: message?.replace(/\\n/g, '\n').replace(/\n/g, '\n\n'),
      role: "assistant"
    });
    this.displayedMessage = '';
    this.messageIndex = 0;
    await this.startTypingNewMessageAsync(message);
  }

   private startTypingNewMessage(newMessage: string): void {
    // Invalidate any ongoing typing session.
    this.typingSessionId++;
    this.messageIndex = 0;
    this.displayedMessage = '';

    // The local replacement for line-breaks or double line breaks:
    const processedMessage = newMessage
      .replace(/\\n/g, '\n')
      .replace(/\n/g, '\n\n');

    // Begin typing with the current session ID
    this.typeMessage(processedMessage, this.typingSessionId);
  }

  private typeMessage(message: string, sessionId: number) {
    if (sessionId !== this.typingSessionId) {
      return; // Stop typing.
    }

    if (this.messageIndex < message.length) {
      this.displayedMessage += message[this.messageIndex];
      this.messageIndex++;
      setTimeout(() => this.typeMessage(message, sessionId), this.typingSpeed);
      setTimeout(() => this.scrollToBottom(), 0);
      setTimeout(() => {
        const container = this.scrollContainer;
        if(container && container.nativeElement){
          container.nativeElement.scrollTop = container.nativeElement.scrollHeight;
        }
      });
    }
  }

  startTypingNewMessageAsync(newMessage: string): Promise<void> {
    return new Promise<void>((resolve) => {
      this.typingSessionId++;
      const currentSessionId = this.typingSessionId;
      this.messageIndex = 0;
      this.displayedMessage = '';

      const processedMessage = newMessage
        .replace(/\\n/g, '\n')
        .replace(/\n/g, '\n\n');

      const type = () => {
        if (currentSessionId !== this.typingSessionId) {
          return resolve(); // cancelled
        }

        if (this.messageIndex < processedMessage.length) {
          this.displayedMessage += processedMessage[this.messageIndex++];
          setTimeout(type, this.typingSpeed);

          setTimeout(() => {
            const container = this.scrollContainer;
            if (container?.nativeElement) {
              container.nativeElement.scrollTop = container.nativeElement.scrollHeight;
            }
          });
        } else {
          resolve(); // ✅ Done typing
        }
      };

      type();
    });
  }

  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;

    if (!input.files || input.files.length === 0) return;

    this.imgUpload.addFiles(input.files);

    input.value = '';
  }

  removeUpload(id: string): void {
    this.imgUpload.remove(id);
  }

  canSubmit(queue: UploadQueueItem[]): boolean {
    const hasText = !!this.inputText?.trim();
    const hasDoneImages = queue.some(item => item.status === 'done' && item.url);
    const hasUploading = queue.some(item => item.status === 'pending' || item.status === 'uploading');

    return (hasText || hasDoneImages) && !hasUploading;
  }

  ngOnDestroy(): void {
    if (this.offCanvasSubscription) {
      this.offCanvasSubscription.unsubscribe();
    }
    if (this.updateBuilderComponentSubscription) {
      this.updateBuilderComponentSubscription.unsubscribe();
    }
    if(this.messageAIModuleSubscription){
      this.messageAIModuleSubscription.unsubscribe();
    }
    if(this.getAIModuleHistorySubscription){
      this.getAIModuleHistorySubscription.unsubscribe();
    }
  }
}
